import PropTypes from 'prop-types';
import { createRef, PureComponent } from 'react';

import { CustomerFormValuesType } from 'Type/Account.type';

import MyAccountConfirmIdForm from './MyAccountConfirmIdForm.component';

/** @namespace PeggysagePwa/Component/MyAccountConfirmIdForm/Container */
export class MyAccountConfirmIdFormContainer extends PureComponent {
    static propTypes = {
        customerType: PropTypes.string.isRequired,
        fileType: PropTypes.string.isRequired,
        formStrings: PropTypes.objectOf(PropTypes.string),
        onSkip: PropTypes.func,
        onSubmit: PropTypes.func,
        onChangeFile: PropTypes.func,
        isSkipDisabled: PropTypes.bool,
        isSubmitDisabled: PropTypes.bool,
        defaultValues: CustomerFormValuesType
    };

    static defaultProps = {
        formStrings: {},
        onSkip: null,
        onSubmit: null,
        onChangeFile: null,
        isSkipDisabled: false,
        isSubmitDisabled: false,
        defaultValues: {}
    };

    state = {
        isFileLoaded: false,
        file: null
    };

    fieldRef = createRef();

    containerFunctions = {
        onSkip: this.onSkip.bind(this),
        onSubmit: this.onSubmit.bind(this),
        onChangeFile: this.onChangeFile.bind(this),
        setRefFieldFile: this.setRefFieldFile.bind(this)
    };

    componentDidUpdate(prevProps) {
        const { fileType } = this.props;
        const { fileType: prevFileType } = prevProps;

        if (fileType !== prevFileType) {
            this.setState({
                isFileLoaded: false,
                file: null
            });
        }
    }

    containerProps() {
        const {
            customerType, fileType, formStrings, isSkipDisabled, isSubmitDisabled, defaultValues
        } = this.props;
        const { isFileLoaded } = this.state;

        return {
            customerType,
            fileType,
            formStrings,
            isSkipDisabled,
            isFileLoaded,
            isSubmitDisabled,
            defaultValues
        };
    }

    onSkip(e) {
        const { fileType, onSkip } = this.props;
        const { file: fileData } = this.state;

        const file = {
            [fileType]: fileData
        };

        if (onSkip) {
            onSkip(e, { file });
        }
    }

    setRefFieldFile(elem) {
        if (elem && this.fieldRef !== elem) {
            this.fieldRef = elem;
        }
    }

    onChangeFile(e, { fileData }) {
        const { fileType, onChangeFile } = this.props;

        const fileDataObj = fileData ? JSON.parse(fileData) : null;

        this.setState({
            file: fileDataObj,
            isFileLoaded: !!fileData
        });

        if (onChangeFile) {
            onChangeFile(e, { file: { [fileType]: fileDataObj } });
        }
    }

    onSubmit(e) {
        const { fileType, onSubmit } = this.props;
        const { file: fileData } = this.state;

        const file = {
            [fileType]: fileData
        };

        if (onSubmit) {
            onSubmit(e, { file });
        }
    }

    render() {
        return (
            <MyAccountConfirmIdForm
              { ...this.containerFunctions }
              { ...this.containerProps() }
            />
        );
    }
}

export default MyAccountConfirmIdFormContainer;
